import React from 'react';
import {
  Box, Button,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { useLoyaltyPageContext } from '@gamiphy/loyalty/loyaltyPage/context';
import { useIsSmallScreen } from '@gamiphy/loyalty/loyaltyPage/hooks';

const ConfirmPhone: React.FC<{
  onDone: (phone: string) => void,
  unverifiedPhone: string,
  onEdit: () => void,
}> = ({
  unverifiedPhone,
  onDone,
  onEdit,
}) => {
  const [verifiying, setVerifiying] = React.useState(false);
  const isMobile = useIsSmallScreen();
  const { cashbackProgram: { onAssignPhone }, isMobilePreview } = useLoyaltyPageContext();

  const onVerify = React.useCallback(async () => {
    setVerifiying(true);
    await onAssignPhone(unverifiedPhone);
    onDone(unverifiedPhone);
  }, [unverifiedPhone]);

  return (
    <Box display="flex" gap={1} width="100%" mt={1}>
      <Button
        variant="outlined"
        onClick={onEdit}
        fullWidth={isMobile || isMobilePreview}
        color="inherit"
        sx={{
          fontSize: 14,
          borderColor: '#D0D5DD',
          py: 1,
          px: 2.5,
        }}
      >
        <Trans
          i18nKey="cashbackPopup.number.edit"
          defaults="Edit my number"
        />
      </Button>
      <Button
        variant="contained"
        onClick={onVerify}
        fullWidth={isMobile || isMobilePreview}
        disabled={verifiying}
        sx={{
          fontSize: 14,
          py: 1,
          px: 2.5,
        }}
      >
        <Trans
          i18nKey="shared.verify"
          defaults="Verify"
        />
      </Button>
    </Box>
  );
};

export default observer(ConfirmPhone);
